"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsMenu = void 0;
const typestyle_1 = require("typestyle");
const react_1 = __importDefault(require("react"));
const Menu_1 = require("./Menu");
const index_1 = require("../../../icons/index");
const Colors_1 = require("../../../../Colors");
const DetailMenuItem_1 = require("./DetailMenuItem");
const Main = typestyle_1.style({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    $nest: {
        '&.Selected': {
            color: Colors_1.Colors.green[0],
        },
    },
});
const Circle = typestyle_1.style({
    borderRadius: 6,
    width: 12,
    height: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `solid 1px`,
    borderColor: Colors_1.Colors.grey[0],
    $nest: {
        '&.Selected': {
            borderColor: Colors_1.Colors.green[0],
        },
    },
});
exports.OptionsMenu = (_a) => {
    var { children, options, onCheck, hideMenu } = _a, props = __rest(_a, ["children", "options", "onCheck", "hideMenu"]);
    return (react_1.default.createElement(Menu_1.Menu, Object.assign({ hideMenu: hideMenu }, props), Object.keys(options).map((n) => {
        return (react_1.default.createElement(DetailMenuItem_1.DetailMenuItem, { key: n, onClick: () => onCheck(n) },
            react_1.default.createElement("div", { className: `${Main} ${options[n] ? 'Selected' : ''}` },
                react_1.default.createElement("span", null, n),
                react_1.default.createElement("div", { className: `${Circle} ${options[n] ? 'Selected' : ''}` }, options[n] ? react_1.default.createElement(index_1.Tick, null) : react_1.default.createElement(react_1.default.Fragment, null)))));
    })));
};
